import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import BtnGoBack from "../../components/common/btnGoBack";
import Loadding from "../../components/common/loadding";
import CountCourse from "../../components/schedule/setting/countCount";
import HeadderSend from "../../components/send/headderSend";
import { Path } from "../../constants/enum/path.emum";
import scheduleService from "../../services/schedule.service";
import userService from "../../services/user.service";

type paramType = {
  scheId: string;
};

const SendDoc = () => {
  const params = useParams<paramType>();

  // const location: any = useLocation();
  // const { schedule } = location.state;
  const user = JSON.parse(localStorage.getItem("user") ?? "false");

  const [curri, setCurri] = useState([]);
  const [schedule, setSchedule] = useState<any>();
  const [status, setStatus] = useState(true);

  //useEffect ดึงหลักสูตรตัวเองมา
  useEffect(() => {
    (async () => {
      await scheduleService
        .getById(Number(params.scheId))
        .then(async (res: any) => {
          // console.log(res.data.type);
          setSchedule(res.data);

          const curri = await userService
            .getId(user.id)
            .then((res1) =>
              res1.data.curriculum.filter((c: any) => c.type === res.data.type)
            );
          if (curri) {
            setCurri(curri);
          }
          setStatus(false);
        });
    })();
  }, []);

  if (status) {
    return <Loadding />;
  }
  return (
    <HeadderSend scheId={params.scheId}>
      {/* หลักสูตรที่ต้องส่งเอกสาร {schedule.type === "tqf" ? "มคอ." : "อชว."} */}

      <table className="table table-hover table-responsive">
        <thead className="table-dark">
          <tr>
            <th>ชื่อย่อ</th>
            <th>ชื่อหลักสูตร</th>
            <th>ระดับ</th>
            <th>จำนวนรายวิชาที่ต้องส่ง</th>
            <th>Handle</th>
          </tr>
        </thead>
        <tbody>
          {curri.length > 0 &&
            curri.map((curri: any) => {
              return (
                <tr key={curri.id}>
                  <td>{curri.shortName}</td>
                  <td>{curri.name}</td>
                  <td>{curri.level}</td>
                  <td>
                    <CountCourse schedule={schedule.id} curri={curri} />
                  </td>

                  <td>
                    <Link
                      to={{
                        pathname: `${Path.SENDDOC}/${params.scheId}/${curri.id}`,
                      }}
                      className="btn btn-sm btn-primary text-white"
                    >
                      <i className="bi bi-pencil-square"></i> ส่งเอกสาร
                    </Link>
                  </td>
                </tr>
              );
            })}

          {!(curri.length > 0) && (
            <tr>
              <th colSpan={4} className="text-danger">
                <i className="bi bi-folder-x"></i> ไม่พบหลักสูตรที่ต้องส่งเอกสาร
              </th>
            </tr>
          )}
        </tbody>
      </table>

      <BtnGoBack />
    </HeadderSend>
  );
};

export default SendDoc;
